module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_1@2x.55ddd077.png";